import { styled } from "@obby/components";

export const Box = styled("div", {
  variants: {
    variant: {
      salesBanner: {
        textAlign: "center",
        borderRadius: ".25rem"
      },
      section: {
        maxWidth: "72rem",
        margin: "0 auto"
      },
      points: {
        display: "flex",
        flexDirection: "column",

        "@smd": {
          flexDirection: "row",
          gap: ".5rem"
        },
        "@lg": {
          gap: "1rem",
          justifyContent: "space-between"
        }
        // flexWrap: "wrap",
        // justifyContent: "space-between"
      },
      item: {
        width: "100%",
        marginBottom: "$4",
        backgroundColor: "#fff",
        borderRadius: "$standard",
        paddingX: "1rem",
        paddingY: "2.5rem",
        WebkitBoxShadow: "4px 5px 10px 0px rgba(0, 0, 0, 0.03)",
        boxShadow: "4px 5px 10px 0px rgba(0, 0, 0, 0.03)",

        "@md": {
          width: "22rem",
          padding: "40px 32px",
          marginBottom: "0px"
        }
      },
      itemImage: {
        maxWidth: "9.4rem",
        margin: "0 auto 1.875rem",

        "@smd": {
          margin: "0 auto .875rem",
          width: "5rem"
        },

        "@lg": {
          width: "7rem"
        }
      },
      imageTitle: {
        fontFamily: "$foundersGrotesk",
        fontSize: "$24",
        lineHeight: "1",
        fontWeight: "$3",
        color: "$ebonyClay",
        marginBottom: "$4",

        "@smd": {
          fontSize: "$18"
        },

        "@lg": {
          fontSize: "$20"
        }
      },
      imageDescription: {
        fontFamily: "$foundersGrotesk",
        fontSize: "$lParagraph",
        lineHeight: "1.2",
        fontWeight: "$1",
        color: "$ebonyClay",
        filter: "opacity(0.6)",

        "@smd": {
          fontSize: "$16"
        },

        "@lg": {
          fontSize: "$18"
        }
      }
    },
    size: {
      normal: {
        padding: "1.875rem 1.25rem",
        "@sm": {
          padding: "3.75rem 1.875rem"
        }
      },
      small: {
        padding: "0"
      }
    }
  }
});

export const Text = styled("h2", {
  variants: {
    variant: {
      title: {
        fontFamily: "$foundersGrotesk",
        fontSize: "$32",
        lineHeight: "1",
        fontWeight: "$3",
        color: "$ebonyClay",
        margin: "0 0 30px",
        textTransform: "uppercase"
      }
    }
  }
});

export const Img = styled("img", {
  "@smd": {
    maxWidth: "100%",
    objectFit: "cover"
  }
});
